module.exports = __webpack_public_path__ + "public/SiteIcons/darkModeIcon.svg?49dbfa86";